import { useState, useEffect } from "react";
import { Carousel } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { getFirestore } from "../../config/firebase";
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";
import Loading from "../Loading/Loading";
import "./Slider.scss";

const ALT = "Montironi GAC";

const isWhatsAppSlide = (item) => item?.link === true;

const getSlideUrl = (item) => {
  if (isWhatsAppSlide(item)) return null;
  const link = typeof item?.link === "string" ? item.link.trim() : "";
  if (!link || link === "#") return null;
  return link;
};

const SlideContent = ({ item, onWhatsAppClick }) => {
  const img = <img className="d-block w-100 img-fluid" src={item.slider} alt={ALT} />;

  if (isWhatsAppSlide(item)) {
    return (
      <button
        type="button"
        className="hero-slider__slide-btn"
        onClick={onWhatsAppClick}
        aria-label="Consultar por WhatsApp"
      >
        {img}
      </button>
    );
  }

  const url = getSlideUrl(item);
  if (!url) return img;

  const isExternal = /^https?:\/\//i.test(url);
  return (
    <a
      href={url}
      target={isExternal ? "_blank" : "_self"}
      rel={isExternal ? "noopener noreferrer" : undefined}
    >
      {img}
    </a>
  );
};

const SlideCarousel = ({ items, onWhatsAppClick }) => {
  if (!items.length) return null;

  const showControls = items.length > 1;

  return (
    <Carousel className="hero-slider__carousel" indicators={showControls} controls={showControls}>
      {items.map((item, index) => (
        <Carousel.Item key={index}>
          <SlideContent item={item} onWhatsAppClick={onWhatsAppClick} />
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

const getSlides = (banners, { convencionalOnly = false } = {}) => {
  if (!banners[0]) return { desktop: [], mobile: [] };

  const filterItems = (items) => {
    const list = items || [];
    if (!convencionalOnly) return list;
    const filtered = list.filter((b) => b.convencional === true);
    return filtered.length > 0 ? filtered : list;
  };

  return {
    desktop: filterItems(banners[0].desktop),
    mobile: filterItems(banners[0].mobile),
  };
};

const Slider = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { openConsultaForm } = useWhatsAppConsulta();

  const handleWhatsAppSlide = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "consultar",
      seccion: "slider",
    });
    openConsultaForm();
  };

  useEffect(() => {
    const obtenerDatos = async () => {
      const datosLocales = sessionStorage.getItem("sliders-gac");
      if (datosLocales) {
        setBanners(JSON.parse(datosLocales));
        setLoading(false);
        return;
      }

      const db = getFirestore();
      try {
        const data = await db.collection("sliders-gac").get();
        const arrayData = data.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        sessionStorage.setItem("sliders-gac", JSON.stringify(arrayData));
        setBanners(arrayData);
      } catch (error) {
        console.error("Error al obtener datos de Firestore: ", error);
      } finally {
        setLoading(false);
      }
    };

    obtenerDatos();
  }, []);

  const pathTipo = location.pathname.split("/").filter(Boolean).pop() || "todos";
  const showSlider = pathTipo === "todos" || pathTipo === "convencional";
  const { desktop, mobile } = getSlides(banners, { convencionalOnly: pathTipo === "convencional" });

  if (loading) {
    return <Loading styles="mt-5 pt-5 pb-5" />;
  }

  if (!showSlider) {
    return null;
  }

  return (
    <div id="inicio" className="hero-slider">
      <div className="d-md-block d-none">
        <SlideCarousel items={desktop} onWhatsAppClick={handleWhatsAppSlide} />
      </div>
      <div className="d-md-none d-block">
        <SlideCarousel items={mobile} onWhatsAppClick={handleWhatsAppSlide} />
      </div>
    </div>
  );
};

export default Slider;
